<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('barion_informations')"
    :max-width="800"
    color="auto"
    action-text="Mizu?"
    activator-link
    @escape="closeDialog"
  >
    <template v-slot:info>
      <div class="ma-3">
        <h1>Barion Információ</h1>

        <p class="font-weight-bold">
          A vásárlás során átirányítunk a Barion fizetési felületére, ahol bármilyen bankkártyával fizethetsz.<br>
          Bankkártya adataid a Cumuluslog.com szolgáltatási felülethez nem jutnak el. Magyar Nemzeti Bank engedély szám: H-EN-I-1064/2013
        </p>

        <p>Az Cumuluslog a repülés adminisztráció területén elsőként vezeti be a Barion elfogadórendszerét, melynek segítségével bankkártyával, és újdonságként a Magyar Nemzeti Bank által is elfogadott e-pénzzel is lehetőség nyílik fizetésre, így a biztonságos online fizetés gyorsabbá és kényelmesebbé is vált. Az új fizetési szolgáltatást 2022. november 15-től érhetik el a felhasználók.</p>

        <h1>Mit jelent a Barion™?</h1>

        <p>A Barion elektronikus fizetéseket lebonyolító szolgáltatás, amivel <b>kényelmesen és biztonságosan tudsz bankkártyával vagy előre feltöltött egyenleggel fizetni</b> webáruházakban, mobil alkalmazásokban, vagy barátaidnak.</p>

        <p>A szolgáltatást nyújtó Barion Payment Zrt. a <b>Magyar Nemzeti Bank felügyelete alatt álló</b> e-pénz kibocsátó, engedélyének száma: H-EN-I-1064/2013.</p>

        <h1>Fizess kényelmesen bankkártyával</h1>

        <p>A bankkártyás fizetéshez az eddigiekkel megegyező módon elég megadni bankkártyád számát, a lejárati dátumot és a hátoldalon található CVC kódot, valamint egy működő e-mail címet.</p>

        <p>Ezen felül lehetőséged van regisztrálni a Barion rendszerbe, <b>ekkor soha többé nem kell begépelned a kártyaadataid</b> egyetlen Barion elfogadóhelyen sem, a fizetéshez elég az e-mail címed és jelszavad. Ez nem csak kényelmes, de a biztonságodat is növeli!</p>

        <a
          href="https://www.barion.com"
          target="_blank"
        >
          <v-img
            :src="require('@/assets/barion/barion-card-strip-intl__small.png')"
            width="400px"
          />
        </a><br>
        <p>Fizetéshez használhatod</p>
        <ul>
          <li>Mastercard vagy Maestro bankkártyádat</li>
          <li>Visa vagy Electron bankkártyádat</li>
          <li>Amex bankkártyádat</li>
        </ul>

        <h1>Fizess kényelmesen bankkártya nélkül</h1>

        <p><b>Ha nincsen bankkártyád, fizetéshez használhatod az előre feltöltött Barion e-pénz egyenlegedet</b>, amelyet átutalással vagy készpénz befizetéssel tudsz feltölteni, illetve amire ismerőseid, üzletfeleid tudnak neked pénzt küldeni. Ebben az esetben e-mail címed és jelszavad megadásával tudsz fizetni.</p>

        <h1>Ingyenes</h1>

        <p>A bankkártyás fizetésnek a <b>vásárló részére nincs és nem is lehet felára</b>. A regisztráció és a Barion mobilalkalmazás, valamint a pénz fogadása és küldése ingyenes, és az is marad. Nincs havi díj sem.</p>

        <p><b>A Barion egyenlegkezelés is ingyenes</b>, nincs belépési vagy havi díj. Az egyenleg feltöltésének és visszaváltásának vannak szerény díjai, de a banki átutalással történő feltöltés ingyenes.</p>

        <h1>Kövesd vásárlásaid</h1>

        <p>A Barion alkalmazásokkal követheted vásárlásaidat, a weben vagy mobilon. Az ingyenes Barion tárca azonnal jelzi minden vásárlásodat, még azt is látod, mit vettél. Barion egyenleged is itt kezelheted, illetve pénzt küldhetsz vagy fogadhatsz.</p>

        <p>
          <a href="https://secure.barion.com/" target="_blank">
            <img :src="require('@/assets/barion/di-barion-webapp_inxbsl26.png')">
          </a>
          <a href="https://play.google.com/store/apps/details?id=barion.app" target="_blank">
            <img :src="require('@/assets/barion/icon-googleplay_4786r064.png')">
          </a>
          <a href="https://itunes.apple.com/us/app/barion/id896714923?ls=1&amp;mt=8" target="_blank">
            <img :src="require('@/assets/barion/icon-appstore_d7ezfit2.png')">
          </a>
        </p>

        <h1>Első a biztonság</h1>

        <p>A Barion szervereit a Norton/Symantec/Verisign 256 bites SSL titkosítása védi. Fizetés előtt mindig ellenőrizd, hogy valóban a Barion biztonságos szerverén adod meg a fizetéshez szükséges bankkártya adatokat vagy jelszót. <b>A böngésződ zöld színnel jelzi, ha a fizetés biztonságos</b>, és a fizetőoldal tulajdonosát <b>Barion Payment Inc [HU]</b> néven azonosítja:</p>

        <p>A Barion rendelkezik a bankkártyatársaságok által megkövetelt PCI DSS tanúsítvánnyal, így jogosult bankkártyaadatokat kezelni. A Barion szerverek biztonságát a Magyar Nemzeti Bank előírása szerint alakították ki.</p>

        <img width="604" height="232" :src="require('@/assets/barion/Greenbars-SSL-enhanced_validation_certificates-766x318.png')">

        <p>További információ és ingyenes regisztráció: www.barion.com</p>
      </div>
    </template>
  </cumulus-info-dialog>
</template>

<script>
  export default {
    name: 'BarionInformations',
    data () {
      return {
        dialogInfo: false,
      }
    },
    computed: {
      calc () {
        try {
          return JSON.parse(this.transaction.calc)
        } catch {
          return null
        }
      },
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
      },
    },
    mounted () {
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
